import { c as _c } from "react/compiler-runtime";
import { Button } from '@7f-ui/components/button/button';
import { Divider } from '@7f-ui/components/divider/divider';
import { SimpleModal } from '@7f-ui/components/modal/simple-modal';
import type { AccommodationFacilityType, AccommodationRoomFacilityType } from '@data-access/graphql/schema.types';
import { filterFacilityHighlights } from '@feat/feat-accommodation/availability';
import { AccommodationRoomFacilitiesFlags } from '@feat/feat-accommodation/details';
import { shopTestId } from '@utils/utils-shop-test-ids';
import { useState } from 'react';
import type { AccommodationFragment } from 'src/lib/backend/documents/accommodation';
import { FacilitiesList } from './facilities-list';
type FacilitiesModalProps = {
  accommodation: AccommodationFragment;
};
export function FacilitiesModal(t0) {
  const $ = _c(15);
  const {
    accommodation
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  if (!accommodation) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Button variant="secondary" onClick={() => setIsOpen(true)} data-testid={shopTestId("FacilitiesModal.showAll")}>Alle anzeigen</Button>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setIsOpen(false);
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== accommodation.room) {
    t3 = accommodation.room && <><AccommodationRoomFacilitiesFlags facilities={filterFacilityHighlights(accommodation.room.facilityTypes).slice(0, 12)} /><Divider /></>;
    $[2] = accommodation.room;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== accommodation.room?.facilityTypes) {
    t4 = accommodation.room?.facilityTypes.filter(_temp);
    $[4] = accommodation.room?.facilityTypes;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== accommodation.facilityTypes || $[7] !== t4) {
    t5 = <FacilityTypes facilityTypes={accommodation.facilityTypes} roomFacilityTypes={t4} />;
    $[6] = accommodation.facilityTypes;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t5) {
    t6 = <div className="flex flex-col gap-8">{t3}{t5}</div>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== isOpen || $[13] !== t6) {
    t7 = <>{t1}<SimpleModal isOpen={isOpen} onClose={t2} title="Unterkunftsausstattung">{t6}</SimpleModal></>;
    $[12] = isOpen;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}
function _temp(facilityType) {
  return facilityType.id !== 8;
}
type FacilityTypesProps = {
  facilityTypes: AccommodationFacilityType[];
  roomFacilityTypes?: AccommodationRoomFacilityType[];
};
const FacilityTypes = t0 => {
  const $ = _c(10);
  const {
    facilityTypes,
    roomFacilityTypes: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const roomFacilityTypes = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = shopTestId("FacilitiesModal.facilityTypes");
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== facilityTypes) {
    t4 = facilityTypes.map(_temp2);
    $[3] = facilityTypes;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== roomFacilityTypes) {
    t5 = roomFacilityTypes.map(_temp3);
    $[5] = roomFacilityTypes;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = <ul className="flex flex-col divide-y divide-primary/15 *:py-8 *:first:pt-0 *:last:pb-0" data-testid={t3}>{t4}{t5}</ul>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
};
function _temp2(facilityType) {
  return <li key={facilityType.id}><h5 className="mb-8 font-heading2">{facilityType.name}</h5><FacilitiesList facilities={facilityType.facilities} /></li>;
}
function _temp3(facilityType_0) {
  return <li key={facilityType_0.id}><h5 className="mb-8 font-heading2">{facilityType_0.name}</h5><FacilitiesList roomFacilities={facilityType_0.facilities} /></li>;
}